/* eslint-disable arrow-body-style */
import http from '@/utils/http';

export const getRainbowApi: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/permission/rainbow',
    method: 'post',
    data: payload,
  }) as Promise<any>;
}

export function getTrendsList(params: any): Promise<any> {
  return http({
    url: '/api/v1/intelligence_pc/trends/list',
    method: 'post',
    data: params,
  });
}

export function getTrendsInfo(params: any): Promise<any> {
  return http({
    url: '/api/v1/intelligence_pc/trends/info',
    method: 'post',
    data: params,
  });
}

